'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseAxisController=require('../../../../dist-es6/client/directives/plotting/baseAxisController');
const BaseAxisDirective=require('../../../../dist-es6/client/directives/plotting/baseAxisDirective');let

LinearAxisController=class LinearAxisController extends BaseAxisController{
constructor($scope){
super($scope);
}

get _scaleCreator(){
return d3.scale.linear();
}};let


LinearAxisDirective=class LinearAxisDirective extends BaseAxisDirective{
get controller(){return LinearAxisController}};


module.exports=LinearAxisDirective;
//# sourceMappingURL=linearAxisDirective.js.map
